// Concession block geometry (tenant-scoped) — single source of truth, also read
// by scripts/tests in Python. Geometry is authoritative (DMF); a block with an
// empty ring is not yet sourced and is not drawn.
import raw from "./concessionBlocks.json";

export interface ConcessionBlock {
  code: string;                 // "B5/27" — matches the code embedded in plant.location
  operator: string;             // licence operator (per DMF/ODM)
  shore: "offshore" | "onshore";
  tenant: boolean;              // true = a block this portal's tenant operates (emphasised)
  ring: [number, number][];     // closed polygon in [lon, lat] (GeoJSON order)
}

export const CONCESSION_META = {
  vintage: raw.vintage,
  provenance: raw.provenance,
  source: raw.source,
};
// JSON import types ring as number[][] (tuples don't survive JSON inference);
// the generator script guarantees [lon, lat] pairs, so the assertion is safe.
export const CONCESSION_BLOCKS = raw.blocks as unknown as ConcessionBlock[];

/** Parse the concession block code out of a plant.location string, or null. */
export function blockCodeFromLocation(location: string): string | null {
  const m = (location || "").match(/\b([A-Z]\d{1,2}\/\d{2})\b/);
  return m ? m[1] : null;
}

export function blockByCode(code: string | null): ConcessionBlock | undefined {
  if (!code) return undefined;
  return CONCESSION_BLOCKS.find((b) => b.code === code);
}
